import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { ContactSection } from '../contact/ContactSection';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-white dark:bg-[#0C0C0C]" data-id="element-706">
      <Header data-id="element-707" />
      <main className="flex-grow" data-id="element-708">
        {children}
        <ContactSection data-id="element-709" />
      </main>
      <Footer data-id="element-710" />
    </div>;
}